// extracted by mini-css-extract-plugin
export default {"main":"IntroPage_main__wEyP+","title":"IntroPage_title__-gHK4","btn":"IntroPage_btn__LRrcb"};